module.exports = __webpack_public_path__ + "media/images/mobile/logo/footer-logo-029c70783f632ada072679a6e05a85d2.png";